import React, { useState, useEffect } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { 
  Card, 
  Form, 
  Input, 
  Select, 
  Button, 
  message, 
  Tabs 
} from 'antd';
import { getSystem } from '../../graphql/queries';
import { updateSystem } from '../../graphql/mutation';
import './System.css';

const { Option } = Select;

const systemProviders = [
  { value: 'WIRO_PX', label: 'Wiro PX' },
  { value: 'WIRO_KLING', label: 'Wiro Kling' },
  { value: 'WIRO_MINIMAX', label: 'Wiro Minimax' },
  { value: 'WIRO_WAN21', label: 'Wiro Wan21' },
  { value: 'WIRO_BYTEDANCE', label: 'Wiro Bytedance' },
  { value: 'FAL', label: 'Fal' },
  { value: 'WIRO_WAN22_5B', label: 'Wiro Wan22 5B' },
  { value: 'WIRO_WAN22_14B', label: 'Wiro Wan22 14B' },
];

const SystemPage = () => {
  const [activeTab, setActiveTab] = useState('img2Video');
  const [systemData, setSystemData] = useState({
    img2Video: {
      id: '',
      system: '',
      provider: '',
      type: '',
      createdAt: '',
      updatedAt: '',
    },
    text2Video: {
      id: '',
      system: '',
      provider: '',
      type: '',
      createdAt: '',
      updatedAt: '',
    },
    // toolPredict: {
    //   id: '',
    //   system: '',
    //   provider: '',
    //   type: '',
    //   createdAt: '',
    //   updatedAt: '',
    // }
  });

  const [updateSystemMutation] = useMutation(updateSystem);

  const { data: data1 } = useQuery(getSystem, {
    variables: { systemType: 'img2Video' },
  });

  const { data: data2 } = useQuery(getSystem, {
    variables: { systemType: 'text2Video' },
  });


  useEffect(() => {
    if (data1?.getSystem) {
      setSystemData(prev => ({ ...prev, img2Video: data1.getSystem }));
    }
    if (data2?.getSystem) {
      setSystemData(prev => ({ ...prev, text2Video: data2.getSystem }));
    }

  }, [data1, data2]);

  const handleChange = (name, value) => {
    setSystemData(prev => ({
      ...prev,
      [activeTab]: {
        ...prev[activeTab],
        [name]: value
      }
    }));
  };

  const handleUpdate = async () => {
    try {
      const currentSystem = systemData[activeTab];
      await updateSystemMutation({
        variables: {
          updateSystemId: currentSystem.id,
          system: currentSystem.system,
          provider: currentSystem.provider,
          systemType: currentSystem.type,
        },
      });
      message.success(`${activeTab} system has been successfully updated.`);
    } catch (error) {
      message.error('Update failed: ' + error.message);
    }
  };

  const renderSystemForm = () => {
    const currentSystem = systemData[activeTab];
    const isImg2Video = activeTab === 'img2Video';

    return (
      <Form layout="vertical">
        <Form.Item label="Type">
          <Input value={currentSystem.type} disabled />
        </Form.Item>

        <Form.Item label="Provider">
          <Select
            value={currentSystem.provider}
            onChange={(value) => handleChange('provider', value)}
          >
            {systemProviders.map(provider => (
              <Option key={provider.value} value={provider.value}>
                {provider.label}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Created At">
          <Input value={currentSystem.createdAt} disabled />
        </Form.Item>

        <Form.Item label="Updated At">
          <Input value={currentSystem.updatedAt} disabled />
        </Form.Item>

        <Button type="primary" onClick={handleUpdate}>
          Update System
        </Button>
      </Form>
    );
  };

  const items = [
    {
      key: 'img2Video',
      label: `img2Video System (${systemData.img2Video.provider})`,
      children: renderSystemForm(),
    },
    {
      key: 'text2Video',
      label: `text2Video System (${systemData.text2Video.provider})`,
      children: renderSystemForm(),
    },
  ];

  return (
    <div className="system-container">
      <Card>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={items}
          className="system-tabs"
        />
      </Card>
    </div>
  );
};

export default SystemPage; 